export const panenkaSvgIconClass = 'pk-svg__icon';
export const panenkaSvgProductIconClass = 'pk-svg__icon--product';

export const svgProductIconPrimaryColorPlaceholder = '{{primaryColor}}';
export const svgProductIconSecondaryColorPlaceholder = '{{secondaryColor}}';
export const svgProductIconLightColorPlaceholder = '{{lightColor}}';
export const svgProductIconDarkColorPlaceholder = '{{darkColor}}';
export const svgProductIconShadowColorPlaceholder = '{{shadowColor}}';
export const svgProductIconOutlineColorPlaceholder = '{{outlineColor}}';
export const svgProductIconBackgroundColorPlaceholder = '{{backgroundColor}}';

export const SPECIAL_ICONS = ['pitch-product-icon', 'score-product-icon', 'goal-product-icon'];

export const panenkaIconContent = new Map<string, string>();

const requests = new Map<string, Promise<unknown>>();

const fetchSvg = (url: string, sanitize: boolean) => {
  let req: Promise<unknown>;

  if (typeof fetch !== 'undefined' && typeof document !== 'undefined') {
    req = fetch(url).then((rsp) => {
      if (rsp.ok) {
        return rsp.text().then((svgContent) => {
          if (svgContent && sanitize !== false) svgContent = validateContent(svgContent);
          panenkaIconContent.set(url, svgContent || '');
        });
      }
      panenkaIconContent.set(url, '');
    });

    // cache for the same requests
    requests.set(url, req);
    return req;
  }

  panenkaIconContent.set(url, '');
  return Promise.resolve();
};

export const getSvgContent = async (url: string, sanitize: boolean) => {
  // see if we already have a request for this url
  const req = await requests.get(url);
  if (!req) return fetchSvg(url, sanitize);

  return req;
};

export const validateContent = (svgContent: string) => {
  const div = document.createElement('div');
  div.innerHTML = svgContent;

  // setup this way to ensure it works on our buddy IE
  for (let i = div.childNodes.length - 1; i >= 0; i--) {
    if (div.childNodes[i].nodeName.toLowerCase() !== 'svg') {
      div.removeChild(div.childNodes[i]);
    }
  }

  // must only have 1 root element
  const svgElm = div.firstElementChild;
  if (svgElm && svgElm.nodeName.toLowerCase() === 'svg') {
    const svgClass = svgElm.getAttribute('class') || '';
    svgElm.setAttribute('class', `${svgClass} ${panenkaSvgIconClass} ${panenkaSvgProductIconClass}`.trim());
    svgElm.setAttribute('part', 'svg');

    // remove height and width attribute, if for some reason they are still present in the SVG tag
    svgElm.removeAttribute('height');
    svgElm.removeAttribute('width');

    // root element must be an svg
    // lets double check we've got valid elements
    // do not allow scripts
    if (isValid(svgElm as HTMLElement)) {
      return div.innerHTML;
    }
  }
  return '';
};

export const isValid = (elm: HTMLElement) => {
  if (elm.nodeType === 1) {
    if (elm.nodeName.toLowerCase() === 'script') {
      return false;
    }

    const elemAttributesArr = Array.from(elm.attributes);
    for (const element of elemAttributesArr) {
      const val = element.value;
      if (isStr(val) && val.toLowerCase().startsWith('on')) {
        return false;
      }
    }

    const elemNodesArr = Array.from(elm.childNodes);
    for (const node of elemNodesArr) {
      if (!isValid(node as HTMLElement)) {
        return false;
      }
    }
  }
  return true;
};

export const isStr = (val: unknown): val is string => typeof val === 'string';
